"use client"

import { ApplicationInsights } from "@microsoft/applicationinsights-web"
import { useEffect } from "react"

let appInsights: ApplicationInsights | null = null
let loaded = false

function ensureAppInsights(): void {
  if (loaded) return

  const connectionString =
    process.env.AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY
  if (!connectionString) return

  if (!appInsights) {
    appInsights = new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: true,
      },
    })
  }

  appInsights.loadAppInsights()
  loaded = true
}

export default function AppInsights() {
  useEffect(() => {
    ensureAppInsights()
  }, [])

  return null
}
